// extracted by mini-css-extract-plugin
module.exports = {"radio-inputs":"radio-module__radio-inputs___1g-2X","radioInputs":"radio-module__radio-inputs___1g-2X"};